import { Expose, Transform } from 'class-transformer';
import { DropdownModel } from './dropdown-model';
import { ApplicationType, Constants } from '../../common';
import { getCookie } from 'src/app/shared/helper';
export class Category extends DropdownModel {
  @Expose()
  @Transform(({ obj }) => {
    if (obj && obj?.id) {
      return obj?.id
    }
    else if (obj && obj?._id && !obj?.id) {
      return obj?._id
    }
    else {
      return null;
    }
  })
  id: string;
  @Expose() categoryName: string;
  @Expose()
  @Transform(({ obj }) => {
    if (obj && obj?.categoryNameEn) {
      return obj?.categoryNameEn
    }
    else if (obj && obj?.categoryName_english_lower && !obj?.categoryNameEn) {
      return obj?.categoryName_english_lower
    }
    else {
      return null;
    }
  })
  categoryNameEn: string;
  @Expose() isActive: boolean;
  @Expose() applicationType: ApplicationType;

  override get dropDownDisplayName(): string {
    return getCookie(Constants.APP_LANGUAGE_COOKIE_KEY) == 'ar' ? this.categoryName : this.categoryNameEn;
  }

  override get dropDownValue(): Object {
    return this;
  }

  constructor() {
    super();
  }
}
